const language = (state = 'en') => {
    return state;
};

export default language;
